
import apiClient from '../utils/apiClient'

const createAgent = async (formData) => {
    try {
        const response = await apiClient().post('customer_support/create_agent/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (err) {
        // You could do something with the error here, like logging or even re-throwing
        console.log(err);
        throw err;
    }
};

export { createAgent };